<neq-primeng-table
  [nutrients]="nutrients"
  [noPagination]="noPagination"
  [dynamicRequirements]="dynamicRequirements"
  [actions]="actions"
  [activeFilter]="activeFilter"
  [selectableRows]="selectableRows"
  [disableSelectableCell]="disableSelectableCell"
  [dataRows]="data.results"
  [numberDynamicColumn]="numberDynamicColumn"
  [sessionId]="sessionId"
  [cols]="cols"
  [loading]="loading"
  [rowClass]="rowClass"
  [totalRecords]="totalRecords"
  [lazy]="lazy"
  (loadDataEmitter)="requestData($event)"
  [eventDataChecked]="eventDataChecked"
  [initalRawMaterialsData]="initalRawMaterialsData"
  [nutrientsData]="nutrientsData"
  [initNutrientsData]="initNutrientsData"
></neq-primeng-table>
